import React from "react";
import { Button, Stack, Typography, Paper } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Horizontal bar with Sign In and Sign Up buttons, and optional description above.
 * @param {object} props
 * @param {React.ReactNode} [props.description] - Text or JSX to show above the buttons
 * @param {string} [props.redirect] - Path to redirect to after login/signup
 * @returns {JSX.Element}
 */
const SignInSignUp = ({ description, redirect }) => {
  // Build login/signup URLs with redirect param if provided
  const loginUrl = redirect
    ? `/login?redirect=${encodeURIComponent(redirect)}`
    : "/login";
  // const signupUrl = redirect
  //   ? `/signup?redirect=${encodeURIComponent(redirect)}`
  //   : "/signup";
  const signupUrl = "/signup";

  return (
    <Paper
      elevation={2}
      sx={{
        p: 1,
        mb: 2,
        bgcolor: "background.default",
        borderRadius: 2,
        textAlign: "center",
        maxWidth: 600,
        mx: "auto",
      }}
    >
      {description && (
        <Typography variant="body1" sx={{ mb: 2 }}>
          {description}
        </Typography>
      )}
      <Stack direction="row" spacing={2} justifyContent="center">
        <Button
          component={RouterLink}
          to={loginUrl}
          variant="contained"
          color="primary"
          size="large"
        >
          Sign In (Existing Members)
        </Button>
        <Button
          component={RouterLink}
          to={signupUrl}
          variant="outlined"
          color="primary"
          size="large"
        >
          Sign Up (New Members)
        </Button>
      </Stack>
    </Paper>
  );
};

export default SignInSignUp;
